export function init () {
    $(window).on('CookiebotOnConsentReady', function () {
        if (Cookiebot.consent['marketing']) {
            const s = document.createElement('script');
            const e = !document.body ? document.querySelector('head') : document.body;
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://embeds.acswapp.com/accessibility/app.js';
            e.appendChild(s);
        }
    });
}
